import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppNavigate } from '~/pages';
import { fakeItemsArray, I18nReacher, useSpringBigStore, useTransactionDetails } from '@springbig/shared';
import Section from '~/shared/Section';
import { Box, ChevronLeftIcon, HStack, Skeleton } from 'native-base';
import { Caption } from '~/shared/Typography';
import OurPressable from '~/shared/Pressable';
import { useGeneralStyles } from '~/shared/styles';
import TransactionHeader from './TransactionHeader';
import { format } from 'date-fns';

const TransactionDetails = () => {

    const { member, merchant } = useSpringBigStore();
    const { params } = useAppNavigate();
    const { state: { transaction, cardNumber } } = useLocation();
    const gStyle = useGeneralStyles();

    const {
        isLoading,
        transactionRecords
    } = useTransactionDetails(params, transaction);

    const dollarPerPoint = parseFloat(merchant?.dollars_per_point || '0.0');

    const detailsComponentText = (key : string, value: string) => {

        if (key === 'pointsRedeemed') {
            if (transactionRecords.type === 'point conversation') {
                return ((transaction.load_amount_cents / 100) * dollarPerPoint).toFixed(0);
            }

            return '-';
        }

        if (key === 'giftCardDigits') {
            return cardNumber?.substring(cardNumber.length - 4);
        }

        if (key === 'date') {
            return format(new Date(transaction.created_at), 'MM-dd-yyyy HH:mm:ss');
        }

        return value;
    };

    return (
        <Section pb={10}>
            <TransactionHeader />
            <HStack m={4} justifyContent={'space-between'} alignItems={'baseline'}>
                <OurPressable onPress={() => window.history.back()}>
                    <ChevronLeftIcon size="lg" mt={4} color={gStyle.button_background} />
                </OurPressable>
                { isLoading ?
                    <Skeleton.Text lines={1} width={70} />
                    :
                    <Caption text='giftCard.transactions.details.id' textValues={[transaction.id]} />
                }
            </HStack>
            <Box >
                <HStack m={4} >
                    <Caption w={'70%'} text='giftCard.transactions.details.card_holder_name' />
                    <Caption w={'30%'} textAlign={'left'}>
                        {member?.first_name} {member?.last_name}
                    </Caption>
                </HStack>
                <HStack m={4} >
                    <Caption w={'70%'} text='giftCard.transactions.details.customer_authorization' />
                    <Caption w={'30%'} textAlign={'left'} text='giftCard.transactions.details.confirmed' />
                </HStack>
                { isLoading ?
                    fakeItemsArray.map((_, index) => <TransactionDetailsSkeleton key={index} />)
                    :
                    Object.entries(transactionRecords).map(([key, value]) => {

                        return <HStack key={key} m={4} >
                            <Caption w={'70%'} text={`giftCard.transactions.details.${key}` as I18nReacher} />
                            <Caption w={'30%'} textAlign={'start'}>
                                { detailsComponentText(key, value) }
                            </Caption>
                        </HStack>;
                    })
                }
            </Box>
        </Section>
    );
};

const TransactionDetailsSkeleton = () => {

    return (
        <HStack justifyContent={'space-between'} m={4}>
            <Skeleton.Text lines={1} width={70} />
            <Skeleton.Text lines={1} width={70} />
        </HStack>
    );
};

export default TransactionDetails;
